export const LOAD_PAYMENT_TYPE = 'LOAD_PAYMENT_TYPE';
export const SET_PAYMENT_TYPE_PAGINATION = 'SET_PAYMENT_TYPE_PAGINATION';
export const ADD_PAYMENT_TYPE = 'ADD_PAYMENT_TYPE';
export const EDIT_PAYMENT_TYPE = 'EDIT_PAYMENT_TYPE';
export const LOAD_EDITABLE_PAYMENT_TYPE = 'LOAD_EDITABLE_PAYMENT_TYPE';
export const SET_EDITABLE_PAYMENT_TYPE_DATA = 'SET_EDITABLE_PAYMENT_TYPE_DATA';
